import { Injectable, signal } from '@angular/core';

export type SessionTimeout = 'never' | '15' | '30' | '45' | '60';

const SESSION_TIMEOUT_KEY = 'galaxy-session-timeout';

@Injectable({ providedIn: 'root' })
export class PreferencesService {
  readonly sessionTimeout = signal<SessionTimeout>(
    (localStorage.getItem(SESSION_TIMEOUT_KEY) as SessionTimeout | null) ?? 'never'
  );

  setSessionTimeout(value: SessionTimeout): void {
    this.sessionTimeout.set(value);
    localStorage.setItem(SESSION_TIMEOUT_KEY, value);
  }

  initTheme(): void {
    document.documentElement.classList.add('my-app-dark');
  }
}
